// Copyright © 2021 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default Object.freeze({
  DEVICE_ID: 'device-id',
  DEVICE_ADDRESS: 'device-address',
  CLASSES: 'classes',
  FREQUENCY_PLAN: 'frequency-plan',
  LORAWAN_VERSION: 'lorawan-version',
  JOIN_SERVER: 'join-server',
  JOIN_EUI: 'joineui',
  DEV_EUI: 'deveui',
  APP_KEY: 'appkey',
  NETWORK_KEY: 'network-key',
  APP_SESSION_KEY: 'application-session-key',
  REGIONAL_PARAMETERS: 'regional-parameters',
  NETWORK_SESSION_KEY: 'network-session-key',
  DATA_RATE_OFFSET: 'data-rate-offset',
  ACTIVATION_MODE: 'activation-mode',
  GATEWAY_ID: 'gateway-id',
  GATEWAY_EUI: 'gateway-eui',
  ENFORCE_DUTY_CYCLE: 'duty-cycle',
})
